import React from 'react';
import ErrorBoundary from '../components/error-boundary';

const withErrorBoundary = (WrapComponent) => (props) => (
  <ErrorBoundary>
    <WrapComponent {...props} />
  </ErrorBoundary>
);

export default withErrorBoundary;
